import { LocalizedElement } from '../i18n/Language';
import React from 'react';
import { Loader2 } from 'lucide-react';

export const ContentLoader = () =>
<LocalizedElement as="div" className="min-h-[60vh] flex items-center justify-center" data-testid="content-loader">
    <Loader2 className="animate-spin text-blue-600" size={48} />
  </LocalizedElement>;


export default ContentLoader;
